import { FormattedMessage } from 'react-intl';
import {
  IconCustomExport,
  IconInfoSquareRounded,
} from '@rossum/ui/icons/tabler';
import {
  CircularProgress,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  Typography,
} from '@rossum/ui/material';
import { TabNames } from '../types';

type Props = {
  hasError?: boolean;
  isRunning: boolean;
  activeTab: string;
  setActiveTab: (_resizingtab: TabNames) => void;
};

export const OutputBoxMenu = ({
  activeTab,
  hasError,
  isRunning,
  setActiveTab,
}: Props) => (
  <Stack
    direction="column"
    alignItems="center"
    sx={{
      backgroundColor: t => t.palette.background.paper,
    }}
  >
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      useFlexGap
      sx={{
        px: 2,
        py: 0.5,
        width: 1,
        borderTop: t => `1px solid ${t.palette.divider}`,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        useFlexGap
        sx={{ height: 30 }}
      >
        <SvgIcon fontSize="medium" color="action">
          <IconCustomExport />
        </SvgIcon>
        <FormattedMessage id="components.editor.outputBox.title" />
      </Stack>
      {
        // we might want to handle hasError a bit more user friendly - what if there was
        // an error but no response?
        // removed outputValue for this purpose but now it's a bit confusing to see 'Error' with no context
      }
      {!isRunning && hasError && (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ ml: 2 }}>
          <SvgIcon fontSize="medium" color="error">
            <IconInfoSquareRounded />
          </SvgIcon>
          <Typography color="error">
            <FormattedMessage id="components.editor.outputBox.error" />
          </Typography>
        </Stack>
      )}
      {isRunning && (
        <Stack sx={{ mx: 2 }}>
          <CircularProgress size={20} color="inherit" />
        </Stack>
      )}
    </Stack>
    <Stack
      direction="row"
      sx={{
        width: 1,
        border: t => `1px solid ${t.palette.divider}`,
        borderLeftWidth: 0,
        borderRightWidth: 0,
      }}
    >
      <Tabs sx={{ borderBottom: 1, borderColor: 'divider' }} value={activeTab}>
        {(['response', 'log'] as const).map(tab => (
          <Tab
            key={tab}
            label={
              <Typography variant="body2" color="text.primary">
                <FormattedMessage
                  id={`components.editor.outputBox.tabs.${tab}`}
                />
              </Typography>
            }
            value={tab}
            onClick={() => setActiveTab(tab)}
          />
        ))}
      </Tabs>
    </Stack>
  </Stack>
);
